
//send invitation
import CustomizedMenusIcon from "../../assets/invite-sharing.png";
import Invitetractingicon from "../../assets/invite-tracking.png";
import InvitesmartIcon from "../../assets/invite-smart.png";
import Invite from "../../assets/online-digital-invitation-maker.png";

//book priest
import PriestDemandIcon from "../../assets/priestdemanicon.png";
import DollarIcon from "../../assets/Dollaricon.png";
import DiscountIcon from "../../assets/Discounticon.png";
import ThumbIcon from "../../assets/thumbicon.png";
import InvitePriest from "../../assets/invite-priest.png";

//rent from tent
import VendorIcon from "../../assets/VendorIcon.png";
import DiningIcon from "../../assets/DiningtableIcon.png";
import CartIcon from "../../assets/CartIcon.png";
import PriceIcon from "../../assets/PriceIcon.png";
import Rentalhouses from "../../assets/tent-house-rental-services.png";

//ai event
import AiEvent from "../../assets/professional-event-management-services.png";
import { ReactComponent as AiMenuIcon } from "../../assets/CustomizedMenusIcon.svg";

//catering
import CATERING from "../../assets/online-catering-booking-service.png";
import VerifiedCaterersIcon  from "../../assets/VerifiedCaterersIcon.svg";
import TransparentPriceIcon  from "../../assets/transparentPriceIcon.svg";
import ReliableAvailableIcon  from "../../assets/ReliableAvailableIcon.svg";
import ExclusiveDiscounts  from "../../assets/ExclusiveDiscounts.svg";

export const offeringsData = {
  sendInvitation: {
    heading: "Why Thurent Invitations?",
    subHeading: "for \nSmart Guest Management?",
    image: Invite,
    alt:"Online digital invitation maker to create and manage invitation cards with RSVP",
    ABOUT_SECTION_TITLE : "Send Invitations Easily",
    ABOUT_SECTION_SUBTITLE :"and \nManage Guests Smartly",
    ABOUT_SECTION_DESC : `
  Your event deserves the best. With Thurent’s innovative invitation system, you can focus on what truly matters—creating memories that last a lifetime. Make your events unforgettable, track attendance, spend less, and host perfectly with Thurent’s “Perfect Invites” smart invitation and response tracking system.
  `,
    list: [
      {
        title: "Effortless Invitation Sharing",
        description: "Seamlessly send event invites through WhatsApp directly from our app.",
        icon: <img src={CustomizedMenusIcon} alt="Icon" />,
      },
      {
        title: "Real-time RSVP Tracking",
        description: "Get instant responses and keep tabs on your guest count effortlessly.",
        icon: <img src={Invitetractingicon} alt="Icon" />,
      },
      {
        title: "Smart Insights",
        description: "Use attendee data to fine-tune your event spending—reduce waste, enhance experiences.",
        icon: <img src={InvitesmartIcon} alt="Icon" />,
      },
    ],
  },

  bookPriest: {
    heading: "Why Choose Thurent?",
    subHeading: "for \nYour Pooja Services?",
    image: InvitePriest,
    alt:"instant pandit booking with fast confirmation",
    ABOUT_SECTION_TITLE: "Simplify Rituals with Thurent",
    ABOUT_SECTION_SUBTITLE :"and Your Trusted Pandit Booking Platform",
    ABOUT_SECTION_DESC :`
Make every ritual sacred and stress-free with Thurent. Whether you need to book a pandit for puja, marriage, havan, or last rites, 
we connect you with experienced and verified priests. Find pandits near you, or access reliable online pandit booking for smooth, 
virtual puja services. Thurent offers transparent pricing, trusted pandit services online, and easy scheduling to ensure your spiritual needs are 
fulfilled with care and precision. From daily worship to special occasions, Thurent is your one-stop platform to book pandit  online, hire online 
purohit services, or get the best online puja services at your fingertips.



  `,
    list: [
      {
        title: "Expert Priests On-Demand",
        description: "Connect with knowledgeable priests experienced in the rituals you need.",
        icon: <img src={PriestDemandIcon} alt="Icon" />,
      },
      {
        title: "Fair & Transparent Pricing",
        description: "No more unregulated charges—know what you're paying upfront.",
        icon: <img src={DollarIcon} alt="Icon" />,
      },
      {
        title: "Always Available",
        description: "Find a priest even when your go-to is unavailable or out of town.",
        icon: <img src={ThumbIcon} alt="Icon" />,
      },
      {
        title: "Special Discounts",
        description: "Get the best value for your religious and spiritual needs.",
        icon: <img src={DiscountIcon} alt="Icon" />,
      },
    ],
  },

  rentFormTentHouse: {
    heading: "Event Rentals Made Easy",
    subHeading: "Why Choose Thurent \nfor Event Rentals?",
    image: Rentalhouses,
    alt:"Online tent house booking service with complete setup",
    ABOUT_SECTION_TITLE : "Rent from Tent Houses",
    ABOUT_SECTION_SUBTITLE : "and \nSimplify Your Event Planning",
    ABOUT_SECTION_DESC : `
  From small gatherings to grand celebrations, Thurent helps you rent the right items at the right price. Say goodbye to rental hassles and focus on creating memorable events. Find Event Rentals Near You, Plan Your Event with Ease, and Rent from Trusted Tent Houses Today!
  `,
    list: [
      {
        title: "Wide Range of Rentals",
        description: "From tables and chairs to cups, plates, and decor, find everything you need for your event.",
        icon: <img src={DiningIcon} alt="Icon" />,
      },
      {
        title: "Trusted Local Vendors",
        description: "Connect with reliable tent houses near you for quality rentals.",
        icon: <img src={VendorIcon} alt="Icon" />,
      },
      {
        title: "Transparent Pricing",
        description: "Compare costs upfront and choose what fits your budget.",
        icon: <img src={PriceIcon} alt="Icon" />,
      },
      {
        title: "Convenient Booking",
        description: "Rent everything you need without leaving your home.",
        icon: <img src={CartIcon} alt="Icon" />,
      },
    ],
  },

  aienabledevent: {
    heading: "Why Choose Thurent",
    subHeading: "for \nServices?",
    image: AiEvent,
    alt:"Event planning, management and rental setup for all types of events",
     ABOUT_SECTION_TITLE : "Title will be",
     ABOUT_SECTION_SUBTITLE : "here for \n this ",
     ABOUT_SECTION_DESC : `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
  turpis justo, porta non pulvinar id, dictum at metus. Donec congue
  vulputate tortor. Curabitur varius rutrum lacus et porta. Mauris
  laoreet eget arcu mollis tempor. Nunc id interdum augue. Class aptent
  taciti sociosqu ad litora torquent per conubia nostra, per inceptos
  himenaeos. Donec iaculis, leo in dapibus molestie, quam nulla sodales
  lectus, at rutrum nunc turpis ac dolor. Mauris sed elit interdum,
  tristique enim ut, varius augue. Donec varius varius nulla, ut auctor
  ligula. Vestibulum molestie luctus interdum. Nullam fringilla volutpat
  hendrerit. Aliquam erat volutpat. In aliquet consectetur sapien nec
  molestie. Aliquam varius leo volutpat arcu vestibulum ornare eget sit
  amet erat. Maecenas rutrum mattis convallis. Quisque ante nisl,
  hendrerit id dolor a, eleifend cursus turpis. Praesent dignissim
  sapien vitae mollis hendrerit. Vestibulum sodales, tellus sit amet
  convallis finibus, mauris tellus posuere est, a tempus ex est a
  libero. Praesent pretium feugiat nunc, et rhoncus sapien luctus ut.
  Integer a suscipit nisl, eget laoreet justo. Praesent eu tristique ex.
  Ut rutrum odio in velit ultrices, a accumsan dui facilisis. Curabitur
  semper consectetur eleifend. Morbi hendrerit felis leo, eget ornare mi
  consectetur a. Proin dignissim justo non neque semper, at viverra
  augue rutrum.`,
    list: [
      {
        title: "Start Planning Smarter",
      description:
        "Our AI Enabled Event Details gives you step by step details on what and how to conduct the event.",
      icon:<AiMenuIcon />,
      },
    ],
  },

  bookcatering: {
    heading: "Why Choose Thurent",
    subHeading: "for \nCatering Services?",
    image: CATERING,
    alt:"Book catering service with experienced catering professionals",
    ABOUT_SECTION_TITLE : "Title will be",
 ABOUT_SECTION_SUBTITLE : "here for \n this ",
 ABOUT_SECTION_DESC : `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus
turpis justo, porta non pulvinar id, dictum at metus. Donec congue
vulputate tortor. Curabitur varius rutrum lacus et porta. Mauris
laoreet eget arcu mollis tempor. Nunc id interdum augue. Class aptent
taciti sociosqu ad litora torquent per conubia nostra, per inceptos
himenaeos. Donec iaculis, leo in dapibus molestie, quam nulla sodales
lectus, at rutrum nunc turpis ac dolor. Mauris sed elit interdum,
tristique enim ut, varius augue. Donec varius varius nulla, ut auctor
ligula. Vestibulum molestie luctus interdum. Nullam fringilla volutpat
hendrerit. Aliquam erat volutpat. In aliquet consectetur sapien nec
molestie. Aliquam varius leo volutpat arcu vestibulum ornare eget sit
amet erat. Maecenas rutrum mattis convallis. Quisque ante nisl,
hendrerit id dolor a, eleifend cursus turpis. Praesent dignissim
sapien vitae mollis hendrerit. Vestibulum sodales, tellus sit amet
convallis finibus, mauris tellus posuere est, a tempus ex est a
libero. Praesent pretium feugiat nunc, et rhoncus sapien luctus ut.
Integer a suscipit nisl, eget laoreet justo. Praesent eu tristique ex.
Ut rutrum odio in velit ultrices, a accumsan dui facilisis. Curabitur
semper consectetur eleifend. Morbi hendrerit felis leo, eget ornare mi
consectetur a. Proin dignissim justo non neque semper, at viverra
augue rutrum.`,
    list: [
       {
            title: "Customized Menus",
            description:
              "Select vegetarian, non-vegetarian, or a mix to suit your event needs.",
            icon: <img src={CustomizedMenusIcon} alt="Customized Menus" />,
          },
          {
            title: "Verified Local Caterers",
            description:
              "Work with trusted professionals specializing in different types of events.",
            icon: <img src={VerifiedCaterersIcon} alt="Customized Menus" />,
          },
          {
            title: "Transparent Pricing",
            description:
              "Compare upfront rates to avoid surprises and stay within your budget.",
            icon: <img src={TransparentPriceIcon} alt="Customized Menus" />,
          },
          {
            title: "Reliable Availability",
            description:
              "Get catering options even when your regular provider is unavailable.",
            icon: <img src={ReliableAvailableIcon} alt="Customized Menus" />,
          },
          {
            title: "Exclusive Discounts",
            description: "Enjoy savings with special offers through Thurent.",
            icon: <img src={ExclusiveDiscounts} alt="Customized Menus" />,
          },
    ],
  },

};
